import { Link } from "react-router-dom";
import { MARK } from "@/brand/paths";
import { cn } from "@/lib/utils";

/**
 * Selling Sunsets — HORIZON identity.
 * variant: "wordmark" (editorial, default) | "primary" (symbol + wordmark) | "compact" (SS) | "symbol"
 * Colour is inherited (currentColor); size is set by the className height (e.g. h-[13px]).
 */
export const Mark = ({ variant = "wordmark", className, title = "Selling Sunsets", ...rest }) => {
  const { d, viewBox } = MARK[variant];
  return (
    <svg
      viewBox={viewBox}
      className={cn("block w-auto select-none", className)}
      role="img"
      aria-label={title}
      fill="currentColor"
      {...rest}
    >
      <title>{title}</title>
      <path d={d} />
    </svg>
  );
};

export const Wordmark = ({ className, to = "/", onClick, tone = "ink", variant = "wordmark", as }) => {
  const content = (
    <Mark
      variant={variant}
      className={cn(
        "transition-opacity duration-500 hover:opacity-70",
        tone === "light" ? "text-[#F7F5F0]" : "text-[#1A1C1E]",
        className
      )}
    />
  );

  if (as === "span" || !to) {
    return <span className="inline-block" onClick={onClick}>{content}</span>;
  }
  return (
    <Link to={to} onClick={onClick} className="inline-block" aria-label="Selling Sunsets — home" data-testid="wordmark-home">
      {content}
    </Link>
  );
};

export default Wordmark;
